module.exports = __webpack_public_path__ + "static/media/device-info.b6c0387b.png";